import './georgetown2/style';
import FormStructure from './georgetown2/form_structure';

export default FormStructure;